export default __webpack_public_path__ + "static/media/btn_edit_user_blue.5e6bf05a.svg";